export default __webpack_public_path__ + "static/media/7minfitness@2x.0932a9de.jpg";